import CoreClient from "@/domain/core/utils/coreClient";
import {axios} from "@/utils";

const endpoints = {
    tree: '/v3/checkins/{checkin_id}/gallery_tree/{gallery_id}/tree/',
    media: '/v3/checkins/{checkin_id}/gallery_tree/{gallery_id}/media/',
    price_list: '/v3/checkins/{checkin_id}/gallery_tree/{gallery_id}/price_list/',
    add_favorite: '/v3/medias/{media_id}/add-favorite/',
    remove_favorite: '/v3/medias/{media_id}/remove-favorite/'
}

export default {
    async getGalleryTree(checkinId, galleryId) {
        return await CoreClient.get(endpoints.tree.replace('{checkin_id}', checkinId).replace('{gallery_id}', galleryId))
    },

    async getGalleryMedia(checkinId, galleryId, params) {
        return await CoreClient.get(endpoints.media.replace('{checkin_id}', checkinId).replace('{gallery_id}', galleryId), params)
    },

    async getPriceList(checkinId, galleryId, params) {
        return await CoreClient.get(endpoints.price_list.replace('{checkin_id}', checkinId).replace('{gallery_id}', galleryId), params)
    },
    async addToFavourites(media_id) {
        return  await CoreClient.post(endpoints.add_favorite.replace('{media_id}', media_id))
    },
    async removeFromFavourites(media_id) {
        return  await CoreClient.post(endpoints.remove_favorite.replace('{media_id}', media_id))
    }
}